import "./App.scss";
import "ckeditor5/ckeditor5.css";
import "ckeditor5-premium-features/ckeditor5-premium-features.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Main from "./layouts/Main/Main";
import Contact from "./pages/contact-page";
import Blog from "./pages/blog-page";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/effect-cards";
import Tour from "./pages/tour-page";
import FormBook from "./pages/form-book-page";
import HomePage from "./pages/home-page";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "./utils/storage";
import React from "react";
import { refreshToken } from "./redux/actions/authAction";
import LayoutDB from "./layouts/Dashboard";
import Login from "./pages/Admin/Auth/Login";
import MainBlog from "./pages/Admin/Post";
import AddBlog from "./pages/Admin/Post/AddBlog";
import Profile from "./pages/Admin/Profile";
import BlogDetails from "./pages/blog-page/detail";
import AdminContents from "./pages/Admin/Contents";
import UrlsRedirect from "./pages/Admin/Contents/UrlsRedirect/urlRedirector";
import PageNotFound from "./components/404page";
import RenderOtherPages from "./components/renderOtherPages";
import AuthRoute from "./components/AuthRoute";

function App() {
    // const urls = useSelector((state) => state.urls);

  const dispatch = useDispatch();

  React.useEffect(() => {
    const tokenStore = getToken();
    if (tokenStore) {
      dispatch(refreshToken({ access_token: tokenStore }));
    }
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/" element={<Main />}>
        <Route index element={<HomePage />} />
        <Route path="contact" element={<Contact />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:title" element={<BlogDetails />} />
        <Route path="tour" element={<Tour />} />
        <Route path="book" element={<FormBook />} />
      </Route>
      <Route element={<AuthRoute isAuth={false}/>}>
        <Route path="/login" element={<Login />} />
      </Route>

      <Route element={<AuthRoute isAuth={true} />}>
        <Route path="/dashboard" element={<LayoutDB />}>
          <Route path="blog" element={<MainBlog />} />
          <Route index element={<AdminContents />} />
          <Route path="blog/add" element={<AddBlog />} />
          <Route path="blog/edit/:id" element={<AddBlog />} />
          <Route path="profile" element={<Profile />} />
          <Route path="url-redirect" element={<UrlsRedirect />} />
        </Route>
      </Route>

      <Route path="/*" element={<RenderOtherPages />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
